module.exports = __webpack_public_path__ + "img/7esty blUE@3x.316f2bf4.png";